export default function UploadIcon() {
  return (
    <>
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.8667 10.2001C15.2411 10.2001 14.7333 10.7078 14.7333 11.3334V13.6001H2.26667V11.3334C2.26667 10.7078 1.75893 10.2001 1.13333 10.2001C0.507733 10.2001 0 10.7078 0 11.3334V15.3001C0 15.5715 0.295233 15.8667 0.566667 15.8667H16.4333C16.7756 15.8667 17 15.6072 17 15.3001V11.3334C17 10.7078 16.4923 10.2001 15.8667 10.2001ZM6.23333 5.66673H7.36667V10.7667C7.36667 11.3923 7.8744 11.9001 8.5 11.9001C9.1256 11.9001 9.63333 11.3923 9.63333 10.7667V5.66673H10.7667C11.1656 5.66673 11.5181 5.72057 11.7408 5.49674C11.9623 5.27404 11.9623 4.91192 11.7408 4.68866L8.93973 1.29377C8.82073 1.17477 8.66376 1.12376 8.50906 1.13226C8.3538 1.12376 8.19682 1.17477 8.07839 1.29377L5.27736 4.68866C5.05523 4.91192 5.05523 5.27404 5.27736 5.49674C5.49949 5.72057 6.0112 5.66673 6.23333 5.66673Z"
          fill="white"
        />
      </svg>
    </>
  );
}
